module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-SemiBoldItalic-8a51958ab4c6c426432bf6ba21eccd8a.otf";